let notificationAudioContext;

const getNotificationAudioContext = () => {
  if (typeof window === "undefined") return null;

  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext) return null;

  if (!notificationAudioContext) {
    try {
      notificationAudioContext = new AudioContext();
    } catch (error) {
      return null;
    }
  }

  return notificationAudioContext;
};

export const primeChatNotificationSound = () => {
  const context = getNotificationAudioContext();
  if (!context || context.state === "running") return () => {};

  let removeUnlockListeners;
  const unlock = () => {
    context.resume()
      .then(() => {
        if (context.state === "running") {
          removeUnlockListeners();
        }
      })
      .catch(() => {});
  };

  window.addEventListener("pointerdown", unlock, { passive: true });
  window.addEventListener("keydown", unlock, { passive: true });
  window.addEventListener("touchstart", unlock, { passive: true });

  removeUnlockListeners = () => {
    window.removeEventListener("pointerdown", unlock);
    window.removeEventListener("keydown", unlock);
    window.removeEventListener("touchstart", unlock);
  };

  return removeUnlockListeners;
};

export const playChatNotificationSound = () => {
  const context = getNotificationAudioContext();
  if (!context || context.state === "closed") return;

  const play = () => {
    const now = context.currentTime;
    const oscillator = context.createOscillator();
    const gain = context.createGain();

    oscillator.type = "sine";
    oscillator.frequency.setValueAtTime(880, now);
    oscillator.frequency.exponentialRampToValueAtTime(1320, now + 0.16);

    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.12, now + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.2);

    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start(now);
    oscillator.stop(now + 0.2);
  };

  if (context.state === "suspended") {
    context.resume().then(play).catch(() => {});
    return;
  }

  play();
};
